import { render } from "./TwoFactorSettings.vue?vue&type=template&id=93b706e6&scoped=true"
import script from "./TwoFactorSettings.vue?vue&type=script&lang=js"
export * from "./TwoFactorSettings.vue?vue&type=script&lang=js"

import "./TwoFactorSettings.vue?vue&type=style&index=0&id=93b706e6&scoped=true&lang=css"

import exportComponent from "/app/tmp/origina/V3/v2026.25.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93b706e6"]])

export default __exports__